export default {
  namespaced: true,
  state: {
    // 用户信息更新次数，可用于页面响应用户登录操作
    loginCount: 0,
    USERINFO: {
      isTourist: true
    },
    PHONE_LOGIN_COUNT: 0,
    PHONE_LOGIN_TYPE: 'login',
    USER_TOKEN: ''
  },
  mutations: {
    SET_USERINFO (state, value) {
      state.USERINFO = value
    },
    SET_LOGIN_COUNT (state, token) {
      state.loginCount = state.loginCount + 1
      if (token) {
        state.USER_TOKEN = token
      }
    },
    SET_PHONE_LOGIN (state, {type}) {
      state.PHONE_LOGIN_COUNT = state.PHONE_LOGIN_COUNT + 1
      state.PHONE_LOGIN_TYPE = type || state.PHONE_LOGIN_TYPE
    }
  }
}
